import network from '../../utils/network';
import config from '../../config';
import { ACTION_BEGIN, ACTION_FAILURE } from '../app';

export const FETCH_ADMIN_STATS_DAT_SUCCESS = 'FETCH_ADMIN_STATS_DAT_SUCCESS';
export const FETCH_ADMIN_STATS_JSON_SUCCESS = 'FETCH_ADMIN_STATS_JSON_SUCCESS';

export const fetchAdminStatsDat = () =>
  network.actionWrapper(
      `${config.getApiUrl()}/admin-stats.dat`,
      {
          begin: ACTION_BEGIN,
          success: FETCH_ADMIN_STATS_DAT_SUCCESS,
          failure: ACTION_FAILURE,
      });

export const fetchAdminStatsJson = () =>
    network.actionWrapper(
        `${config.getApiUrl()}/admin-stats.json`,
        {
          begin: ACTION_BEGIN,
          success: FETCH_ADMIN_STATS_JSON_SUCCESS,
          failure: ACTION_FAILURE,
        });
